import React, { useCallback, useEffect, useState } from "react";
import "react-dropdown/style.css";
import logo from "./../assets/images/ttecLogo.png";

import { useSelector, useDispatch } from "react-redux";
import { classRequestActions } from "../Store/ClassRequest";
import ClassRequestAdd from "./ClassRequestEdit/ClassRequestEdit";
import ClassRosterId from "./ClassRosterId/ClassRosterId";
import CloseIcon from "@mui/icons-material/Close";

import HeaderMenu from "./HeaderMenu/HeaderMenu";
import Drawer from "@mui/material/Drawer";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import { useNavigate, useLocation } from "react-router-dom";
import { generalStoreActions } from "Store/GeneralStore";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";

import { useTranslation } from "react-i18next";
import i18next from "i18next";
import Tooltip from "@mui/material/Tooltip";

import StorageIcon from "@mui/icons-material/Storage";

import Grid from "@mui/material/Grid";
import classes from "./../components/ParentClientCard/ParentClientCard.module.css";
import UserAccount from "./UserAccount/UserAccount";
import { ROOT } from "./../navigation/CONSTANTS";
import { Box, Chip, IconButton, Typography } from "@mui/material";
import { CustomButton, CustomTooltip } from "./RosterConfig/RosterConfigStyle";
import pillThemeConfig from "styles/pillThemeConfig";
import { useAuth } from "context/AuthContext";

const languagePreferences = [
  { label: "English", value: "en" },
  { label: "French Canadian", value: "fr" },
  { label: "Portuguese", value: "pt" },
  { label: "Spanish", value: "es" },
];

const handleLanguageChange = (e) => {
  i18next.changeLanguage(e.target.value);
};

const Header = () => {
  const { t } = useTranslation(["header"]);
  const navigate = useNavigate();
  const locationHook = useLocation();
  const dispatch = useDispatch();
  const { hasAnyPermission } = useAuth();

  const [state, setState] = React.useState({ right: false });
  const [panCakeState, setPanCakeState] = React.useState({ right: false });
  const [showPanCake, setShowPanCake] = useState(false);
  const [showHeader, setShowHeader] = useState(false);

  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");

  const location = window.location.pathname.split("/");
  const [drawerType, setDrawerType] = useState("add");

  const showAddClassRequestButton = useSelector((state) => state.generalStore);
  const cloneDetails = useSelector((state) => state.generalStore);

  const parentClientId = useSelector((state) => state.parentClientId);
  const assignTraineeData = useSelector((state) => state.assignTrainees);
  const [selectedCloneRequest, setSelectedCloneRequest] = useState("null");

  useEffect(() => {
    if (cloneDetails.cloneDetails.length > 0) {
      setSelectedCloneRequest(cloneDetails.cloneDetails[0].classRosterId);
    }
  }, [cloneDetails]);

  useEffect(() => {
    if (localStorage.getItem("i18nextLang")?.length > 2)
      i18next.changeLanguage("en");

    if (
      hasAnyPermission([
        "PII_Group",
        "PII_Group_Low",
        "PII_Group_Med",
        "PII_Group_FULL",
      ])
    )
      setShowPanCake(true);

    if (location[3]) setFirstName(location[3].replace(/%20/g, " "));
    if (location[4]) setLastName(location[4].replace(/%20/g, " "));
  }, [hasAnyPermission]);

  useEffect(() => {
    let cancelled = false;

    const fetchConfigValue = async () => {
      try {
        if (cancelled) return;

        const noHeaderPages = [
          "pii-report",
          "pii-report-oracle",
          "obtinfo",
          "obtinfobulkedit",
          "contact-roster",
          "pii-ritmticket",
          "learnpoint",
          "centerpoint",
          "obt",
          "welcome",
          "new-roster-config",
          "home",
          "shipping",
          "coreratio",
          "bulkedit",
          "bireport",
          "log-insights",
        ];

        // ASTT-1958 - Since we are checking for lower case below, always provide
        // above noHeaderPages values in lower case.
        const showHeaderValue = !noHeaderPages.includes(
          location[1].toLowerCase(),
        );

        if (!cancelled) {
          setShowHeader(showHeaderValue);
        }
      } catch (error) {
        if (!cancelled) {
          console.error("Failed to fetch config value:", error);
        }
      }
    };

    fetchConfigValue();

    return () => {
      cancelled = true;
    };
  }, [location]);

  const toggleDrawer = (anchor, open, type) => (event) => {
    dispatch(generalStoreActions.updateShowProject(false));
    dispatch(classRequestActions.resetClassReq());
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    )
      return;
    type = type || drawerType;
    setDrawerType(type);
    setState({ ...state, [anchor]: open });
    if (!open) dispatch(generalStoreActions.updateClassRequestCreated(true));
  };

  const toggleDrawerPanCake = (anchor, open, type) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setPanCakeState({ ...state, [anchor]: open });
  };

  const handleCloneDetailsChange = useCallback((e) => {
    setSelectedCloneRequest(e.target.value);
  });

  const handleAddClassRoster = useCallback((data) => {
    if (selectedCloneRequest !== "null") {
      navigate(
        `/new-roster-config/clone/${selectedCloneRequest}/${cloneDetails.classRequestId}/${data}`,
      );
    } else {
      navigate(
        `/new-roster-config/clone/null/${cloneDetails.classRequestId}/${data}`,
      );
    }
  });

  const handleGoBack = () => {
    const { pathname } = locationHook;
    if (pathname === "/rosterSearch") {
      if (parentClientId.parentClientId !== "") {
        navigate(`/parentClient/${parentClientId.parentClientId}`);
      } else {
        navigate(`/home`);
      }
    } else if (pathname === "/home/assignTrainees") {
      const searchedRoster = assignTraineeData?.searchedRoster;
      const classReqId = assignTraineeData?.searchedClassReqId;
      const path =
        searchedRoster !== null &&
        searchedRoster !== "null" &&
        searchedRoster !== 0
          ? `/rosterSearch/null/${searchedRoster}`
          : `/rosterSearch/${classReqId || "null"}/null`;
      dispatch(generalStoreActions.traineeSearch(true));
      navigate(path || ROOT);
    } else if (pathname === "/createIDMTicket") {
      navigate("/home/assignTrainees", {
        state: { classRequestId: assignTraineeData?.classRequestId },
      });
    } else {
      navigate(-1);
    }
  };

  const handleClick = () => {
    if (location[1] !== "trainee-details") {
      navigate("/welcome");
    }
  };

  const renderLogo = () => {
    return location[1] === "trainee-details"
      ? "logo"
      : "logo-section cursor-pointer";
  };

  const renderArrowIcon = () => {
    return (
      <KeyboardArrowLeftIcon
        onClick={(e) => handleGoBack()}
        className="fs-4rem m-l-5 cursor-pointer"
      />
    );
  };

  const prepareChipStyle = (label) => ({
    fontWeight: "bold",
    backgroundColor: pillThemeConfig[label]?.primaryColor,
    color: pillThemeConfig[label]?.fontColor,
    maxWidth: "100px",
    fontSize: "15px",
    position: "relative",
  });

  return (
    <div>
      {showHeader && (
        <div
          className={
            window.location.host !== "astt.ttec.com"
              ? "home-section home-section-container env-devcolor"
              : "home-section home-section-container"
          }
        >
          <Grid className="only-flex align-center" container spacing={2}>
            <Grid item xs={3}>
              <div className="flex-display align-center">
                <div className={renderLogo()}>
                  <CustomButton
                    onClick={handleClick}
                    sx={{
                      border: "none",
                      background: "none",
                      padding: "0",
                      cursor: "pointer",
                    }}
                  >
                    <img alt="logo" height="65px" src={logo} />
                  </CustomButton>
                </div>
                <div className={"logo-title"}>{"Agent State Tracker"}</div>

                {location[1] !== "home" &&
                  location[1] !== "welcome" &&
                  location[1] !== "parentClient" &&
                  location[1] !== "searchResult" &&
                  location[1] !== "requisitionSearch" &&
                  location[1] !== "roster-config" &&
                  location[1] !== "new-roster-config" &&
                  location[1] !== "trainee-details" &&
                  location[1] !== "bulkedit" &&
                  renderArrowIcon()}
              </div>
            </Grid>

            <Grid className="only-flex flex-start" item xs={3.5}>
              {location[1] === "trainee-details" && (
                <div className="m-l-5">
                  <Typography variant="body1" sx={{ fontSize: 16 }}>
                    {firstName} {lastName} - {location[2]}
                  </Typography>
                </div>
              )}
              {location[1] === "parentClient" && (
                <div className="m-l-5">
                  (
                  {cloneDetails.classRequestName +
                    " : " +
                    cloneDetails.classRequestNumbers}{" "}
                  Items )
                </div>
              )}
              {location[1] === "rosterSearch" && (
                <div className="m-l-5 flex-space-between">
                  <div className="width-35">{t("classRoster")} - </div>
                  <div>
                    <Tooltip
                      title={cloneDetails.programName}
                      arrow
                      placement="bottom"
                    >
                      <p className="header-projectName">
                        {cloneDetails.programName}
                      </p>
                    </Tooltip>
                    <Tooltip
                      title={cloneDetails.projectName}
                      arrow
                      placement="bottom"
                    >
                      <p className="header-projectName">
                        {cloneDetails.projectName}
                      </p>
                    </Tooltip>
                  </div>
                </div>
              )}
            </Grid>
            <Grid className="only-flex align-center" item xs={0.5}>
              {(location[1] === "home" || location[1] === "parentClient") &&
              showPanCake ? (
                <div type="img" className="whiteColor">
                  <StorageIcon
                    sx={{ width: "50px", height: "50px" }}
                    className="cursor-pointer"
                    onClick={toggleDrawerPanCake("right", true, "add")}
                  ></StorageIcon>
                </div>
              ) : null}
            </Grid>

            <Grid
              className="only-flex align-center"
              item
              xs={2}
              sx={{ paddingRight: 16, paddingLeft: 23 }}
            >
              {location[1] === "parentClient" && <p>{t("selectLanguage")}</p>}
              {location[1] === "parentClient" && (
                <div className={"align-center flex-display"}>
                  <select
                    onChange={(e) => handleLanguageChange(e)}
                    className="dropdown-css"
                    value={localStorage.getItem("i18nextLng")}
                    placeholder="Select an option"
                  >
                    {languagePreferences.map((itm, i) => {
                      const rowKey = `${itm.label}-${i}`;
                      return (
                        <option key={rowKey} value={itm.value}>
                          {itm.label}
                        </option>
                      );
                    })}
                  </select>
                </div>
              )}
            </Grid>
            <Grid className="only-flex align-center" item xs={3}>
              {showAddClassRequestButton.showAddClassRequest &&
              location[1] !== "home" &&
              location[1] !== "welcome" &&
              location[1] !== "rosterSearch" ? (
                <CustomButton
                  sx={{ width: 385, height: 50 }}
                  className="header-button-cr"
                  onClick={toggleDrawer("right", true, "add")}
                >
                  {t("addNewClassRequestWave")}
                </CustomButton>
              ) : null}
              {cloneDetails.cloneDetails.length > 0 ? (
                <div>
                  <select
                    onChange={(e) => handleCloneDetailsChange(e)}
                    className="dropdown-css"
                    value={selectedCloneRequest}
                    placeholder="Select an option"
                  >
                    {cloneDetails.cloneDetails.map((value, i) => {
                      const rowKey = `${value.classRosterId}-${i}`;
                      return (
                        <option key={rowKey} value={value.classRosterId}>
                          {value.classRosterIdClone}
                        </option>
                      );
                    })}
                  </select>
                </div>
              ) : null}
              {location[1] === "rosterSearch" && (
                <button
                  className="header-button-cr"
                  onClick={(e) => handleAddClassRoster(true)}
                >
                  +
                </button>
              )}
            </Grid>
          </Grid>
          <Box sx={{ display: "flex", alignItems: "center", gap: "5px" }}>
            <HeaderMenu />
            <UserAccount />
          </Box>
        </div>
      )}
      <Dialog
        open={state["right"]}
        fullWidth
        onClose={toggleDrawer("right", false)}
        maxWidth={false}
        PaperProps={{
          sx: { height: "100%", maxWidth: "md" },
        }}
      >
        {cloneDetails.showProject === false && (
          <div>
            <DialogTitle
              sx={{
                paddingTop: 1,
                paddingBottom: 0,
                paddingLeft: 1,
                paddingRight: 1,
              }}
            >
              <Grid container>
                <Grid item xs={8}>
                  <Typography
                    sx={{
                      fontFamily: "urbanist",
                      fontSize: "16px",
                      fontWeight: "bold",
                      color: "#3F5765",
                      marginTop: "10px",
                      marginLeft: "20px",
                    }}
                  >
                    {t("addClassRequestDetails")}
                  </Typography>
                </Grid>
                <Grid item xs={3.5}></Grid>
                <Grid item xs={0.5}>
                  <IconButton onClick={toggleDrawer("right", false, "add")}>
                    <CloseIcon />
                  </IconButton>
                </Grid>
              </Grid>
            </DialogTitle>
            <Grid container>
              <Grid item xs={7}></Grid>
              <Grid item xs={1}>
                <CustomTooltip title={t("ogTitle")} arrow>
                  <Chip label="OG" sx={prepareChipStyle("OG")}></Chip>
                </CustomTooltip>
              </Grid>
              <Grid item xs={1}>
                <CustomTooltip title={t("ldTitle")} arrow>
                  <Chip label="L&D" sx={prepareChipStyle("LD")}></Chip>
                </CustomTooltip>
              </Grid>
              <Grid item xs={1.1}>
                <CustomTooltip title={t("wfmTitle")} arrow>
                  <Chip label="WFM" sx={prepareChipStyle("WFM")}></Chip>
                </CustomTooltip>
              </Grid>
              <Grid item xs={0.9}>
                <CustomTooltip title={t("taTitle")} arrow>
                  <Chip label="TA" sx={prepareChipStyle("TA")}></Chip>
                </CustomTooltip>
              </Grid>
              <Grid item xs={1}>
                <CustomTooltip title={t("opsTitle")} arrow>
                  <Chip label="OPS" sx={prepareChipStyle("OPS")}></Chip>
                </CustomTooltip>
              </Grid>
            </Grid>
          </div>
        )}

        <ClassRequestAdd
          onClose={toggleDrawer("right", false, "add")}
          type="add"
        ></ClassRequestAdd>
      </Dialog>

      <Drawer
        anchor={"right"}
        open={panCakeState["right"]}
        onClose={toggleDrawerPanCake("right", false)}
        PaperProps={{ sx: { width: "50%" } }}
      >
        <div className={"info-class-request"}>
          <Box
            className={classes.classRequestHeading}
            sx={{ fontSize: "38px", padding: 10 }}
          >
            {t("contactRoster")}
          </Box>
          <div className={classes.classRequestHeader}>
            <div className={classes.buttonContainer}>
              <CloseIcon
                onClick={toggleDrawerPanCake("right", false, "edit")}
              ></CloseIcon>
            </div>
          </div>
        </div>

        <Grid item xs={12}>
          &nbsp;
        </Grid>
        <div className={"info-class-request"}>
          <Grid item xs={12}>
            <Typography variant="h6" sx={{ padding: 2 }}>
              {t("selectClassRosterId")}
            </Typography>
          </Grid>
        </div>

        <Grid item xs={12}>
          &nbsp;
        </Grid>

        <div className={"info-class-request"}>
          <ClassRosterId></ClassRosterId>
        </div>
        <Grid item xs={12}>
          <Typography
            variant="h4"
            sx={{ color: "red", padding: "10px", textAlign: "center" }}
          >
            {t("important")}
          </Typography>
          <Typography
            variant="body2"
            sx={{ padding: "10px", textAlign: "center", fontSize: 15 }}
          >
            {t("docSecurity")}
            <br />
            {t("actAsOne")}
          </Typography>
        </Grid>
      </Drawer>
    </div>
  );
};

export default Header;
